export enum UpscaleModelType {
  Basic = "basic",
  Premium = "premium",
}
